import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        goToCheckout  : false,
        csrf          : {},
        urlParameters : {
            emulateJSON: true
        },
        urls      : {},
        resources : {},
        utils     : {},
        views     : {
            cart           : 0,
            login          : 1,
            shipping       : 2,
            shippingmethod : 3,
            billing        : 4,
            promos         : 5,
            payment        : 6,
            confirmation   : 7
        },
        paymentForm        : null,
        paymentFormRef     : null,
        paymentFormSuccess : false,
        paymentMethod      : '',
        activeView         : 0,
        lastStep           : 0,
        cartData           : {},
        selectedCreditCard : '',
        checkoutData       : {
            isMultiShipping : false,
            addingWishlist  : false,
            itemToWishlist  : null,
            productList     : [],
            addressList     : [],
            groups          : [],
            shipments       : [],
            shippingMethods : [],
            shippingStateCode: '',
            orderUuid: ''
        },
        clone: function (obj) {
            return JSON.parse(JSON.stringify(obj));
        },
        notEmpty: function (obj) {
            return (obj) ? Object.keys(obj).length !== 0 : false;
        },
        promoBannerLayout: '',
        isRestrictedDeliveryEnabled: false,
        // set to true after first click on "Continue" CTA if shipping restrictions are applied.
        // Used to determine second click on "Continue" CTA (after which a confirmation dialog will be shown)
        restrictedDeliveryFlag: false
    },
    getters: {
        allCoupons(state) {
            if (state.cartData && state.cartData.basketItems) {
                return state.cartData.basketItems.filter(item => item.isCoupon);
            }
            return [];
        },
        appliedCoupons(state, getters) {
            return getters.allCoupons.filter(coupon => coupon.applied);
        },
        giftCertificates(state) {
            return state.cartData.basketItems ? state.cartData.basketItems.filter(item => item.isGift) : [];
        },
        giftPayments(state) {
            return (state.cartData && state.cartData.giftPayments) ? state.cartData.giftPayments : [];
        },
        restrictedDeliveryBasketItems(state) {
            if (!state.isRestrictedDeliveryEnabled || !state.cartData.basketItems) {
                return [];
            }

            return state.cartData.basketItems.filter(bi => {
                return (
                    bi.restrictedDeliveryStates &&
                    bi.restrictedDeliveryStates.indexOf(state.checkoutData.shippingStateCode) !== -1
                );
            });
        },
        restrictedDeliveryBasketItemIds(state, getters) {
            return getters.restrictedDeliveryBasketItems.map(bi => bi.id);
        },
        restrictedDeliveryBasketItemNamesMarkup(state, getters) {
            return getters.restrictedDeliveryBasketItems.map(bi => {
                return `<li>${bi.name}</li>`;
            }).join('');
        },
        restrictedDeliveryMessageCart(state, getters) {
            const restrictedDeliveryMessageEl = document.getElementById('shipping-restrictions-text-cart');
            const bufferEl = document.createElement('div');

            bufferEl.innerHTML = restrictedDeliveryMessageEl.innerHTML;
            bufferEl.querySelector('.placeholder').innerHTML = getters.restrictedDeliveryBasketItemNamesMarkup;

            return bufferEl.innerHTML;
        },
        restrictedDeliveryMessageCheckout(state, getters) {
            const restrictedDeliveryMessageEl = document.getElementById('shipping-restrictions-text-checkout');
            const bufferEl = document.createElement('div');

            bufferEl.innerHTML = restrictedDeliveryMessageEl.innerHTML;
            bufferEl.querySelector('.placeholder').innerHTML = getters.restrictedDeliveryBasketItemNamesMarkup;

            return bufferEl.innerHTML;
        },
        availableLoyaltyPoints(state) {
            // loyaltyBalances: {
            //     "Points": 66,
            //     "cashback": 9.16
            // }
            if (state.cartData && state.cartData.loyaltyBalances && state.cartData.loyaltyBalances.cashback) {
                return state.cartData.loyaltyBalances.cashback;
            }
            return 0;
        },
        isLoyaltyEnabled(state) {
            return (state.cartData && state.cartData.isLoyaltyEnabled) ? true : false;
        },
        cartData(state) {
            return state.cartData ? state.cartData : {};
        },
        selectableCashRewards(state) {
            if (state.notEmpty(state.cartData.loyaltyBalances)) {
                return state.cartData.loyaltyBalances.selectableCashRewards;
            } else {
                return [];
            }
        },
        callOutMessage(state) {
            if (state.cartData && state.cartData.basketItems) {
                if (state.cartData.basketItems[0] && state.cartData.basketItems[0].adjustments && state.cartData.basketItems[0].adjustments.messages) {
                    return state.cartData.basketItems[0].adjustments.messages[0] || ''; // Note: For now, we are just taking one message from first item.
                }
            }
        }
    },
    mutations: {
        updateCart: function(state, obj) {
            state.cartData = obj;

            if (state.cartData.hasSOR) {
                state.views.promos = -1;
                state.views.payment = 5;
                state.views.confirmation = 6;
            }
        },
        updateView: function (state, num) {
            state.activeView = num;
        },
        updateLastStep: function (state, num) {
            state.lastStep = num;
        },
        updateCheckout: function (state, obj) {
            for (var key in obj) {
                state.checkoutData[key] = obj[key];
            }
        },
        updatePromoBannerLayout(state, newLayout) {
            state.promoBannerLayout = newLayout;
        },
        setShippingState(state, shippingStateCode) {
            state.checkoutData.shippingStateCode = shippingStateCode;
        },
        setRestrictedDeliveryFlag(state, isRestricted) {
            state.restrictedDeliveryFlag = isRestricted;
        }
    },
    actions: {
        pushGTMEvent: function(params, args) {
            if (typeof dataLayer == 'object') {
                var type   = (args.mouseEvent.type == 'mouseover') ? 'hover' : args.mouseEvent.type;
                var action = args.action || type;
                var label  = args.label || window.location.href;
                var event  = {
                    'event'  : type + args.name,
                    'action' : action,
                    'label'  : label
                };

                dataLayer.push(event);
            }
        },
        pushGTMDataLayer: function(params, args) {
            if (typeof dataLayer == 'object') {
                var layer = {
                    'event': args.eventName,
                    'ecommerce': {
                        'currency': params.rootState.cartData.currency,
                        'value': 0
                    }
                };
        
                layer.ecommerce[args.ecommObj] = {
                    items: []
                };
        
                for (var i = 0; i < params.rootState.cartData.basketItems.length; i++) {
                    var item = params.rootState.cartData.basketItems[i];
        
                    //var price = parseFloat(item.price.replace(/[^0-9.-]+/g, ''), 10);
        
                    if (!item.isCoupon && !item.isGift && !item.isDiscount) {
                        layer.ecommerce[args.ecommObj].items.push({
                            'item_id': item.id,
                            'item_name': item.name.replace('"', '').replace('\'', ''),
                            'item_category': item.category,
                            'price': item.price,
                            'quantity': item.qty
                        });
                    }
                }

        
                // Calculate the total value without formatting toFixed(2)
                // layer.ecommerce.value = layer.ecommerce[args.ecommObj].products.reduce(function (sum, product) {
                //     var productValue = product.price * product.quantity;
                //     return sum + productValue;
                // }, 0);
        
                // // Format the total value with two decimal places before pushing to dataLayer
                // layer.ecommerce.value = parseFloat(layer.ecommerce.value.toFixed(2));
        
                layer.ecommerce.value = parseFloat(params.rootState.cartData.totals.orderTotal.replace(/[^\d.]/g, ''));

                if (args.other) {
                    Object.assign(layer.ecommerce[args.ecommObj], args.other);
                }
        
                dataLayer.push(layer);
            }
        },
        
        async getCart({ state, commit, dispatch }) {
            const { data } = await axios.get(state.urls.getCart);
            commit('updateCart', data);

            dispatch('updatePromoBannerLayout');
        },
        async updatePromoBannerLayout({ state, commit }) {
            const { data } = await axios.get(state.urls.getPromoBannerLayout);

            commit('updatePromoBannerLayout', data);
        },
        /**
         * Calls the Remove Product function on the Controller
         * @param {String} item - The ID of the item to be removed
         * @param {String} type - The type of item to be removed
         * @param {Boolean} updateRelatedState - should related state be updated.
         * For multiple products removal should be set to true only for the lastly removed product
         */
        async removeProduct({ state, commit, dispatch }, { itemId, type, updateRelatedState = true }) {
            let responseData;

            try {
                const { data } = await axios.post(state.urls.remItem, {item: itemId, type: type});
                responseData = data;
            } catch (error) {
                var msg = (typeof error === 'object') ? JSON.stringify(error) : error;
                axios.post(state.urls.logError, {
                    file: 'store.js',
                    func: 'removeProduct',
                    msg: msg
                });
                throw new Error(error);
            }

            if (updateRelatedState) {
                commit('updateCart', responseData);
                dispatch('triggerMiniCartUpdate');
                dispatch('updatePromoBannerLayout');
            }
        },
        async removeProductsBulk({ state, dispatch }, productIdsList) {
            const productsList = state.cartData.basketItems.filter(bi => {
                return productIdsList.indexOf(bi.id) !== -1;
            });

            for (const product of productsList) {
                const type = product.isGift ? 'gift' : 'product';
                const updateRelatedState = productsList.indexOf(product) === productsList.length - 1;

                await dispatch('removeProduct', { itemId: product.id, type, updateRelatedState });
            }
        },
        /**
         * Fires event to request minicart area update
         */
        triggerMiniCartUpdate() {
            const event = document.createEvent('Event');
            event.initEvent('minicartchanged', true, true);

            window.dispatchEvent(event);
        }
    }
});
